import axios from 'axios'
import Configuration from '../config/configuration';

class VideosService {

    constructor() {
        this.config = new Configuration();
    }

    getVideos() {
        return axios.get(this.config.apiBaseUrl + `videos`);
    }

    getVideosWithType(type) {
        return axios.get(this.config.apiBaseUrl + `videos?type=${type}`);
    }
    
    typesWithVideos() {

        return axios.get(this.config.apiBaseUrl + `videos/typeasparent`);
    }

    getVideosPaginated(data) {
        const { pageNo, pageSize, tabName } = data;
        return axios.get(this.config.apiBaseUrl + `videos?page=${pageNo}&pageSize=${pageSize}&type=${tabName}`);
    }

    getVideoTypes() {
        return axios.get(this.config.apiBaseUrl + `videos/types`);
    }

    getVideosWithSearchQuery(data) {
        const { pageNo, pageSize, searchQuery, type } = data;
        const query = `${searchQuery? '&searchQuery='+searchQuery: ''}${type? '&type=' + type : ''}`;
        return axios.get(this.config.apiBaseUrl + `videos?page=${pageNo}&pageSize=${pageSize}${query}`);
    }

    getVideosSearchAutoComplete(searchStr) {
        const instance = axios.create(); //to escape site wide loader create separate instance of axios
        return instance.get(this.config.apiBaseUrl + `videos/autocomplete?searchStr=${searchStr}`);
    }

    getVideoDetailById=(id)=>{

        return axios.get(this.config.apiBaseUrl + `videos/${id}`);
    }

    handleError(error) {
        console.log(error.message);
    }

}

export default VideosService;
